import * as React from 'react';
import { Container } from 'types/Watchlist';
import { Button } from '@mui/material';
import { TrashIcon } from '@heroicons/react/24/solid';
import { ContainerTitle } from './ContainerTitle';

interface Props {
  container: Container;
  onDelete: (transactionId: string) => void;
  className?: string;
}

export const TitleBar: React.FC<Props> = (props) => {
  const { container, onDelete, className } = props;
  return (
    <div className={`space-y-4 ${className}`}>
      <div className="flex items-center justify-between">
        <ContainerTitle container={container} />
        <div className="flex space-x-4 items-center">
          <Button
            startIcon={<TrashIcon className="w-4 h-4" />}
            variant="outlined"
            color="info"
            onClick={() => onDelete(container.transaction)}
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};
TitleBar.displayName = 'Shipments.DetailDrawer.Header.TitleBar';
